import axios from 'axios';

const updatePrevisaoEntregaProduto = (id, idProduto, data) => axios.put(`/compras/${id}/produtos/${idProduto}/previsao-entrega`, data);
const finalizarEntregaProduto = (id, idProduto) => axios.put(`/compras/${id}/produtos/${idProduto}/entregas`, {});

export default {
  updatePrevisaoEntregaProduto,
  finalizarEntregaProduto,
};
